import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const statusOptions = [
        { id: 'A', text: 'Active' },
        { id: 'I', text: 'Inactive' }
    ];

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const finalLayout = useMemo(() => {
        return PrimaryLayout;
    }, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    const handlePrimaryFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("STATUS", statusOptions);
        }, 100);
    }, [loadLookupClient]);

    useEffect(() => {
        loadLookupClient("STATUS", statusOptions);
    }, [loadLookupClient, props.formFields?.STATUS]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='2E7A3D95-6B41-4C58-9F2D-8A1C5E0B7D63'
                layoutName='WMExceptionPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
